import { useEffect, useState } from 'react';
import { Box, Center, Loader, Stack, Text } from '@mantine/core';
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { DEV_SWITCHER_OFFSET } from '@/components/dev-user-switcher';
import { completeKeycloakCallback } from '@/contexts/auth';

export const Route = createFileRoute('/auth/callback')({
  component: AuthCallbackPage,
});

function AuthCallbackPage() {
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    completeKeycloakCallback()
      .then(() => navigate({ to: '/' }))
      .catch(() => setError('Sign-in failed. Try again.'));
  }, [navigate]);

  return (
    <Box style={{ minHeight: `calc(100dvh - ${DEV_SWITCHER_OFFSET})`, background: 'var(--cd-signin-gradient)' }}>
      <Center h={`calc(100dvh - ${DEV_SWITCHER_OFFSET})`}>
        <Stack align="center" gap="md">
          {!error && <Loader size="lg" />}
          <Text c={error ? 'red' : 'dimmed'} size="sm">
            {error ?? 'Signing in…'}
          </Text>
        </Stack>
      </Center>
    </Box>
  );
}
